import { action, computed, persist, thunk } from 'easy-peasy';
import moment from 'moment';
import { TUserCards, UserInfoModel, UserModel } from './types';
import { getUser } from '@http/endpoints/user';

const userModel: UserModel = {
  userInfo: {},
  session: persist({ sessionInfo: {}, giftCode: null }, { storage: 'localStorage' }),
  settings: undefined,
  setSettings: action((state, payload) => {
    state.settings = { ...payload };
  }),
  setUser: action((state, payload) => {
    state.userInfo = payload;
  }),
  setSession: action((state, payload) => {
    if (payload) {
      state.session.sessionInfo = {
        refresh_token: payload.refresh_token || '',
        token: payload.token,
      };
    } else {
      state.session.sessionInfo = {};
    }
  }),
  setSubscription: action((state, payload) => {
    if (payload) {
      state.subscription = {
        ...state.subscription,
        ...payload,
      };
    }
  }),
  setGiftCode: action((state, payload) => {
    state.session.giftCode = payload;
  }),

  setCardAsPrimary: action((state, payload) => {
    let cards = [...((state.userInfo as UserInfoModel).cards || [])];
    if (!cards?.length) return;
    cards = cards.map(x => ({
      ...x,
      is_primary: 0,
    }));
    const index = cards.findIndex((card) => card.id === +payload);
    if (index === -1) return;
    const newCard = {
      ...cards[index],
      is_primary: 1,
    };
    cards.splice(index, 1, newCard);
    (state.userInfo as UserInfoModel).cards = [...cards];
  }),

  removeCard: action((state, payload) => {
    const cards = [...((state.userInfo as UserInfoModel).cards || [])];
    if (!cards?.length) return;
    const index = cards.findIndex((card) => card.id === +payload);
    if (index === -1) return;
    cards.splice(index, 1);
    (state.userInfo as UserInfoModel).cards = [...cards];
  }),

  addCard: action((state, payload) => {
    let cards = (state.userInfo as UserInfoModel)?.cards || [];
    if (!cards?.length) return;
    if (cards.length) {
      cards = cards.map(x => ({
        ...x,
        is_primary: 0,
      }));
    }
    const obj = { ...(payload || {}) } as any;
    const index = cards.findIndex((card) => card.id === +obj?.id);
    if (index === -1) {
      cards = [payload, ...cards];
    } else {
      cards.splice(index, 1, {
        ...obj,
      });
    }
    (state.userInfo as UserInfoModel).cards = cards;
  }),

  updateCard: action((state, payload) => {
    const cards = [...((state.userInfo as UserInfoModel).cards || [])];
    if (!cards?.length) return;
    const obj = { ...(payload || {}) } as any;
    const index = cards.findIndex((card) => card.id === +obj?.id);
    if (index === -1) return;
    cards.splice(index, 1, obj);
    (state.userInfo as UserInfoModel).cards = [...cards];
  }),

  setAuthInfo: thunk(async (actions, payload) => {
    await actions.setSession(payload);
    await actions.updateUser();
  }),
  updateUser: thunk(async (actions, _payload) => {
    getUser().then(async ({ data }: any) => {
      if (data) {
        if (
          data?.data?.data?.user_info?.blocked_from_site === 1 ||
          data?.data?.data?.user_info?.blocked_from_site === '1'
        ) {
          actions.removeAuthInfo();
          window.location.href = 'https://beate-uhse-movie.zendesk.com/hc/de/requests/new';
        } else {
          const temp = {
            ...data.data.data.user,
            ...data.data.data.user_info,
            cards: data.data.data.cards,
          };
          await actions.setUser(temp);
        }
      }
    });

  }),

  removeAuthInfo: thunk(async (actions) => {
    await actions.setUser({});
    await actions.setSession({});
  }),
  isAuthenticated: computed((state) => {
    if (state.session.sessionInfo.token) return true;
    else return false;
  }),
  isUsedRegistrationPromo: computed((state) => {
    if (!(state?.userInfo as UserInfoModel)?.id) return true;
    return !!((state?.userInfo as UserInfoModel)?.is_used_register_promo);
  }),
  isNewsletterSubscribed: computed((state) => {
    return (state.userInfo as any).is_newsletter_subscribed;
  }),
  isCancelPossible: computed((state) => {
    return !!(state?.subscription?.is_cancel_possible);
  }),
  cancelSubDate: computed((state) => {
    if (!state.subscription) return undefined;
    return moment((state.subscription as any).last_real_day).subtract(5, 'days').format('DD.MM.YYYY');
  }),
  isCardExpired: computed((state) => !!(state?.cards?.find(x => x.is_primary) as any)?.is_expired),
  isUserCardExpired: computed((state) => !!(state?.userInfo as UserInfoModel)?.is_card_expired),
  isSubscriptionEpoch: computed((state) => !!(state.userInfo as UserInfoModel)?.is_subscription_epoch),
  expireSoon: computed((state) => {
    if (!state?.cards?.length) return;
    return state?.cards?.find(x => x.is_primary && x.is_expire_soon);
  }),
  isExpiredSoon: computed((state) => {
    if (!state?.cards?.length) return false;
    return !!state?.cards?.find(x => x.is_primary)?.is_expire_soon;
  }),
  cards: computed((state) => (state.userInfo as UserInfoModel)?.cards),
  getCard: computed((state) => (id: number) => (state.userInfo as UserInfoModel)?.cards?.find(card => card.id === id) as TUserCards),
};

export default userModel;
